/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-case-declarations */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable default-case */
/* eslint-disable no-new */
/* eslint-disable radix */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import React from 'react';

import {
  CircularProgress,
  Collapse,
  Fade,
  Grid,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import format from 'date-fns/format';
import capitalize from 'lodash.capitalize';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import ImageWrapper from 'components/ImageWrapper';
import InputNumber from 'components/Inputs/ManufactureInputs/InputNumber';
import { PrintLabel } from 'components/PrintLabel';
import ConfigGrayYellowBg from 'images/icons/configsAndSetups/configGrayBgYellowOutlineBorderBlack.svg';
import ConfigGrayNoBg from 'images/icons/configsAndSetups/configGrayNoBgOutlineBorderBlack.svg';
import EngineIconGrey from 'images/icons/configsAndSetups/configIconGrey.svg';
import ConfigLightBlueYellowBg from 'images/icons/configsAndSetups/configLightBlueBgYellowOutlineBorderNavyBlue.svg';
import ConfigLightBlueNoBg from 'images/icons/configsAndSetups/configLightBlueNoBgOutlineBorderNavyBlue.svg';
import PrinterDisabledIcon from 'images/icons/objects/printers/printerLightGrayOutline.svg';
import PrinterIcon from 'images/icons/objects/printers/printerYellowOutline.svg';
import storeIconWS from 'images/icons/objects/stores/storeIconWS.svg';
import VirtualProduction from 'images/icons/signals/alerts/alertWhiteLightBlueBgCircle.svg';
import OutProgrammingProduction from 'images/icons/signals/alerts/alertWhiteNavyBlueBgCircle.svg';
import OutProgrammingChangedProduction from 'images/icons/signals/alerts/alertWhiteYellowBgCircle.svg';
import CheckedCircleIcon from 'images/icons/signals/checks/checkWhiteGreenBgRoundedNavyBorder.svg';
import CancelProduction from 'images/icons/signals/closesAndCancels/cancelWhiteRedBgRoundedNavyBorder.svg';
import DeleteIcon from 'images/icons/signals/closesAndCancels/closeWhiteNavyGrayBgRounded.svg';
import ProductionIcon from 'images/icons/signals/moreInfos/threeDotsWhiteLightBlueBgRoundedNavyBorder.svg';
import PauseProductionIcon from 'images/icons/signals/pausesAndStops/pauseWhiteYellowMustardBgRoundedNavyBorder.svg';
import PlayIcon from 'images/icons/signals/playsAndStarts/playWhiteNavyBlueBgRoundedNavyBorder.svg';
import ClockGreenIcon from 'images/icons/objects/clocks/clockColoredLightGreenBgRounded.svg';
import ClockGreenDisabledIcon from 'images/icons/objects/clocks/clockLightGreenNoBgLightGreenBorderRounded.svg';
import { ButtonStatus } from 'styles/buttons';
import { increaseDate } from 'utils/formatDate';
import { getRestaurantbyId } from 'utils/getRestaurants';
import { checkIsBefore } from 'utils/isBefore';
import ValidationLength from 'utils/utils';


import { useStyles, PercentBox, TooltipFinish } from './styles';
import { handleFields } from './utils';
import GenerateHashId from 'utils/geneareteHashId';

function DesktopRows({
  cards,
  setManufacture,
  setCurrentTransformationCardItems,
  setUpdateValue,
  updateValue,
  handleCardQuantity,
  handleItemDiscard,
  optionsDiscard,
  getDuration,
  handleClickOpenModal,
  setLoading,
  manufactures,
  loading,
  handleUpdate,
  handlePopoverClick,
  setCardDate,
  setPopoverData,
  handleOpenItems,
  diffViewMonetary,
  handleDialogClickOpen,
  setDeleteData,
  modalStates,
  setModalStates,
  modalSettings,
  setModalSettings,
  stores,
  companyActive,
  companyGroup,
  updateQuantityInitialValue,
  setCurrentCard,
  setProductionInputControlAnchor,
  loadingCardCostInfos,
  setLoadingCardCostInfos,
  handleGetCardInfos,
  cardCostInfos,
  setCardCostInfos,
  parametersInfos,
  handlePrintPortion
}) {
  const classes = useStyles();
  const {companies, companiesActive} = useSelector(state => state?.user);
  const isLargeScreen = window.innerWidth > 1536

  const renderManualProductionIcon = (currentManufacture) => {
    const includeAction = currentManufacture?.actions?.find(el => el?.type === "INCLUDE")
    const finishAction = currentManufacture?.actions?.find(el => el?.type === "FINISH")
    const cardUnit = currentManufacture?.un?.abbreviation
    const includeQuantity = includeAction?.quantity
    const finishQuantity = finishAction?.quantity
    const currentUser = finishAction ? finishAction?.user : includeAction?.user
    const currentDate = finishAction ? finishAction?.date : includeAction?.date
    const formattedCardQuantity = (currentManufacture?.quantity || 0)?.toLocaleString('pt-br', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    })
    const formattedCardYield = (currentManufacture?.yield || 0)?.toLocaleString('pt-br', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    })

    const renderManualIncludedProduction = () => (
      <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0">
              Produção fora da programação
            </p>

            <p className="bold mt10 mb0">
              INCLUÍDO PELA PRODUÇÃO: <br/>
              Qtde: {formattedCardQuantity} {cardUnit} <br/>
              Rendimento: {formattedCardYield} {cardUnit} <br/>
              Usuário: {currentUser} <br/>
              Data: {moment(currentDate)?.format("DD/MM/YYYY")} - {moment(currentDate)?.format('HH:mm')} hs
            </p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img 
          src={OutProgrammingProduction}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip>
    )

    const renderManualIncludedFinishedProduction = () => (
      includeQuantity === finishQuantity ? (
        renderManualIncludedProduction()
      ) : includeQuantity !== finishQuantity ? (
        <Tooltip
          title={
            <div style={{ padding: '4px' }}>
              <p className="bold mb0">
                Produção fora da programação <br/>
                *Alterada após inclusão 
              </p>

              <p className="bold mt10 mb0">
                INCLUÍDO PELA PRODUÇÃO: <br/>
                Qtde: {includeAction?.quantity?.toLocaleString('pt-br', {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3
                })} {cardUnit} <br/>
                Rendimento: {includeAction?.yield?.toLocaleString('pt-br', {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3
                })} {cardUnit} <br/>
                Usuário: {includeAction?.user} <br/>
                Data: {moment(includeAction?.date)?.format("DD/MM/YYYY")} - {moment(includeAction?.date)?.format('HH:mm')} hs
              </p>

              <p className="bold mt10 mb0"> 
                ALTERADO NA PRODUÇÃO: <br/>
                Qtde: {finishAction?.quantity?.toLocaleString('pt-br', {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3
                })} {cardUnit} <br/>
                Rendimento: {finishAction?.yield?.toLocaleString('pt-br', {
                  minimumFractionDigits: 3,
                  maximumFractionDigits: 3
                })} {cardUnit} <br/>
                Usuário: {finishAction?.user} <br/>
                Data: {moment(finishAction?.date)?.format("DD/MM/YYYY")} - {moment(finishAction?.date)?.format('HH:mm')} hs
              </p>
            </div>
          }
          aria-label="filters"
          placement="right-start"
        >
          <img
            src={OutProgrammingChangedProduction}
            style={{ width: 16, height: 15 }}
          />
        </Tooltip> 
      ) : null
    ) 

    return (
      finishAction
        ? renderManualIncludedFinishedProduction()
        : renderManualIncludedProduction() 
    )
  }

  const renderEngineProductionIcon = (currentManufacture) => {
    const toProduceAction = currentManufacture?.actions?.find(el => el?.type === "TO_PRODUCE")
    const finishAction = currentManufacture?.actions?.find(el => el?.type === "FINISH")
    const toProduceQuantity = toProduceAction?.quantity
    const finishQuantity = finishAction?.quantity
    const cardEngine = currentManufacture?.engine
    const engineQuantity = currentManufacture?.engine?.quantity
    const cardUnit = currentManufacture?.un?.abbreviation

    const includedAndNotChangedProduction = () => (
      <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0">
              Sugestão Copiloto: <br/>
              Qtde de acordo com a sugestão
            </p>

            <p className="bold mt10 mb0">
              INCLUÍDO PELO COPILOTO: <br/>
              Qtde: {toProduceAction?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {toProduceAction?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Usuário: {toProduceAction?.user} <br/>
              Data: {moment(toProduceAction?.date)?.format("DD/MM/YYYY")} - {moment(toProduceAction?.date)?.format('HH:mm')} hs
            </p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img
          src={ConfigLightBlueNoBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip> 
    )

    const includedAndChangedProduction = () => (
      <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0">
              Sugestão Copiloto: <br/>
              Qtde sugerida alterada pelo usuário
            </p>

            <p className="bold mt10 mb0">
              SUGESTÃO COPILOTO: <br/>
              Qtde: {cardEngine?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {cardEngine?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
            </p>

            <p className="bold mt10 mb0">
              ALTERADO NO COPILOTO: <br/>
              Qtde: {toProduceAction?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {toProduceAction?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Usuário: {toProduceAction?.user} <br/>
              Data: {moment(toProduceAction?.date)?.format("DD/MM/YYYY")} - {moment(toProduceAction?.date)?.format('HH:mm')} hs
            </p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img
          src={ConfigGrayNoBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip> 
    )

    const finishedAndOnlyFinishDiffProduction = () => (
      <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0">
              Sugestão Copiloto: <br/>
              Qtde de acordo com a sugestão <br/>
              *Alterada após inclusão
            </p>

            <p className="bold mt10 mb0">
              INCLUÍDO PELO COPILOTO: <br/>
              Qtde: {toProduceAction?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {toProduceAction?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Usuário: {toProduceAction?.user} <br/>
              Data: {moment(toProduceAction?.date)?.format("DD/MM/YYYY")} - {moment(toProduceAction?.date)?.format('HH:mm')} hs
            </p>

            <p className="bold mt10 mb0">
              ALTERADO NA PRODUÇÃO: <br/>
              Qtde: {finishAction?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {finishAction?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Usuário: {finishAction?.user} <br/>
              Data: {moment(finishAction?.date)?.format("DD/MM/YYYY")} - {moment(finishAction?.date)?.format('HH:mm')} hs
            </p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img
          src={ConfigLightBlueYellowBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip> 
    )

    const finishedAndFinishAndToProduceDiffProduction = () => (
      <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0">
              Sugestão Copiloto: <br/>
              Qtde de acordo com a sugestão <br/>
              *Alterada após inclusão
            </p>

            <p className="bold mt10 mb0">
              SUGESTÃO COPILOTO: <br/>
              Qtde: {cardEngine?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {cardEngine?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
            </p>

            <p className="bold mt10 mb0">
              ALTERADO NO COPILOTO: <br/>
              Qtde: {toProduceAction?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {toProduceAction?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Usuário: {toProduceAction?.user} <br/>
              Data: {moment(toProduceAction?.date)?.format("DD/MM/YYYY")} - {moment(toProduceAction?.date)?.format('HH:mm')} hs
            </p>

            <p className="bold mt10 mb0">
              ALTERADO NA PRODUÇÃO: <br/>
              Qtde: {finishAction?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Rendimento: {finishAction?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {cardUnit} <br/>
              Usuário: {finishAction?.user} <br/>
              Data: {moment(finishAction?.date)?.format("DD/MM/YYYY")} - {moment(finishAction?.date)?.format('HH:mm')} hs
            </p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img
          src={ConfigGrayYellowBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip> 
    )

    const renderFinishedProductionIcon = () => (
      toProduceQuantity === engineQuantity && toProduceQuantity === finishQuantity
        ? includedAndNotChangedProduction()
        : toProduceQuantity === engineQuantity && toProduceQuantity !== finishQuantity
          ? finishedAndOnlyFinishDiffProduction()
          : toProduceQuantity !== engineQuantity && toProduceQuantity === finishQuantity
            ? includedAndChangedProduction()
            : finishedAndFinishAndToProduceDiffProduction()
    )

    const renderNotFinishedProductionIcon = () => (
      toProduceQuantity === engineQuantity
        ? includedAndNotChangedProduction()
        : includedAndChangedProduction()
    )

    return (
      finishAction 
        ? renderFinishedProductionIcon()
        : renderNotFinishedProductionIcon()
    )
  }

  function getLatestByType(data, type) {
    return data
        ?.filter(item => item.type === type) // Filtra objetos pelo tipo
        ?.sort((a, b) => new Date(b.date) - new Date(a.date)) // Ordena pela data mais recente
        ?.at(0); // Pega o primeiro (mais recente)
}

  const renderIcon = (manufacture) => {
    const typeInclude = getLatestByType(manufacture?.actions,'INCLUDE')
    const typeToProduce = getLatestByType(manufacture?.actions,'TO_PRODUCE')
    const typeStart = getLatestByType(manufacture?.actions,'START')


    if (manufacture?.changeQuantityIcon === 'EXCLAMATION_BLUE') {
      return <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0">
              FORA DA PROGRAMAÇÃO!
            </p>
            ---------------------------------------------
            <p className="bold mb0">INCLUÍDO NA PRODUÇÃO:</p>
            <p className="bold mb0">Qtde: {manufacture?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Rendimento: {manufacture?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Usuário: {typeInclude?.user ? typeInclude?.user : '-'}</p>
            <p className="bold mb0">Data: {moment(manufacture?.created_at)?.format("DD/MM/YYYY")} - {moment(manufacture?.created_at)?.format('HH:mm')} hs</p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img 
          src={OutProgrammingProduction}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip>
    }

    if(manufacture?.changeQuantityIcon === 'GEAR_BLUE') {
      return <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <div style={{color: '#7583F0'}}>
            <p className="bold mb0" style={{color: '#7583F0'}}>
              COM SUGESTÃO NO COPILOTO
            </p>
            <p className="bold mb0" style={{color: '#7583F0'}}>Qtde: {manufacture?.engine.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            <p className="bold mb0" style={{color: '#7583F0'}}  >Rendimento: {manufacture?.engine?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            ---------------------------------------------
            </div>
            <p className="bold mb0">ALTERADO NO COPILOTO</p>
            <p className="bold mb0">Qtde: {typeToProduce?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Rendimento: {typeToProduce?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Usuário: {typeToProduce?.user ? typeToProduce?.user : '-'}</p>
            <p className="bold mb0">Data: {moment(typeToProduce?.date)?.format("DD/MM/YYYY")} - {moment(typeToProduce?.date)?.format('HH:mm')} hs</p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img 
          src={ConfigLightBlueNoBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip>
    }

    if(manufacture?.changeQuantityIcon === 'GEAR_SILVER_YELLOW') {
      return <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0" style={{color: '#F2B90D'}}>
              *Alterado na Produção
            </p>
            <br/>
            <p className="bold mb0" style={{color: '#9296AC'}}>
              SEM SUGESTÃO NO COPILOTO<br/>
              ---------------------------------------------
            </p>
            <p className="bold mb0">INCLUÍDO PELO COPILOTO:</p>
            <p className="bold mb0">Qtde: {typeToProduce?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            <p className="bold mb0">Rendimento: {typeToProduce?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            <p className="bold mb0">Usuário: {typeToProduce?.user ||'-'}</p>
            <p className="bold mb0">Data: {moment(typeToProduce?.date)?.format("DD/MM/YYYY")} - {moment(typeToProduce?.date)?.format('HH:mm')} hs</p>
            ---------------------------------------------
            <p className="bold mb0">ALTERADO NA PRODUÇÃO</p>
            <p className="bold mb0">Qtde: {typeStart?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Rendimento: {typeStart?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Usuário: {typeStart?.user || '-'}</p>
            <p className="bold mb0">Data: {moment(typeStart?.date)?.format("DD/MM/YYYY")} - {moment(typeStart?.date)?.format('HH:mm')} hs</p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img 
          src={ConfigGrayYellowBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip>
    }

    if (manufacture?.changeQuantityIcon === 'GEAR_SILVER') {
      return <Tooltip
      title={
        <div style={{ padding: '4px' }}>
          <p className="bold mb0" style={{color: '#9296AC'}}>
            SEM SUGESTÃO NO COPILOTO
          </p>
          <p className="bold mb0" style={{color: '#9296AC'}}>
          ---------------------------------------------
          </p>
          <p className="bold mb0">INCLUÍDO PELO COPILOTO</p>
          <p className="bold mb0">Qtde: {typeToProduce?.quantity?.toLocaleString('pt-br', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            })} {manufacture?.un?.abbreviation}</p>
          <p className="bold mb0">Rendimento: {typeToProduce?.yield?.toLocaleString('pt-br', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            })} {manufacture?.un?.abbreviation}</p>
          <p className="bold mb0">Usuário: {typeToProduce?.user || '-'}</p>
          <p className="bold mb0">Data: {moment(typeToProduce?.date)?.format("DD/MM/YYYY")} - {moment(typeToProduce?.date)?.format('HH:mm')} hs</p>
        </div>
      }
      aria-label="filters"
      placement="right-start"
    >
      <img 
        src={ConfigGrayNoBg}
        style={{ width: 16, height: 15 }}
      />
    </Tooltip>
    }

    if (manufacture?.changeQuantityIcon === 'GEAR_BLUE_YELLOW') {
      return <Tooltip
        title={
          <div style={{ padding: '4px' }}>
            <p className="bold mb0" style={{color: '#F2B90D'}}>
              *Alterado na Produção
            </p>
            <br/>
            <div style={{color: '#7583F0'}}>
            <p className="bold mb0" style={{color: '#7583F0'}}>
              COM SUGESTÃO NO COPILOTO
            </p>
            <p className="bold mb0" style={{color: '#7583F0'}}>Qtde: {manufacture?.engine.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            <p className="bold mb0" style={{color: '#7583F0'}}  >Rendimento: {manufacture?.engine?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            ---------------------------------------------
            </div>
            <p className="bold mb0">INCLUÍDO PELO COPILOTO:</p>
            <p className="bold mb0">Qtde: {typeToProduce.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
            <p className="bold mb0">Rendimento: {typeToProduce?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}
            </p>
              ---------------------------------------------
            <p className="bold mb0">ALTERADO NA PRODUÇÃO:</p>
            <p className="bold mb0">Qtde: {typeStart?.quantity?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Rendimento: {typeStart?.yield?.toLocaleString('pt-br', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              })} {manufacture?.un?.abbreviation}</p>
            <p className="bold mb0">Usuário: {typeStart?.user ||'-'}</p>
            <p className="bold mb0">Data: {moment(typeStart?.date)?.format("DD/MM/YYYY")} - {moment(typeStart?.date)?.format('HH:mm')} hs</p>
          </div>
        }
        aria-label="filters"
        placement="right-start"
      >
        <img 
          src={ConfigLightBlueYellowBg}
          style={{ width: 16, height: 15 }}
        />
      </Tooltip>
    }

    if (manufacture?.changeQuantityIcon === 'EXCLAMATION_YELLOW') {
      return <Tooltip
      title={
        <div style={{ padding: '4px' }}>
          <p className="bold mb0" style={{color: '#F2B90D'}}>
            *Alterado na Produção
          </p>
          <br/>
          <p className="bold mb0">
            FORA DA PROGRAMAÇÃO!
          </p>
          ---------------------------------------------
          <p className="bold mb0">INCLUÍDO PELA PRODUÇÃO:</p>
          <p className="bold mb0">Qtde: {typeInclude?.quantity?.toLocaleString('pt-br', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            })} {manufacture?.un?.abbreviation}</p>
          <p className="bold mb0">Rendimento: {typeInclude?.yield?.toLocaleString('pt-br', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            })} {manufacture?.un?.abbreviation}</p>
          <p className="bold mb0">Usuário: {typeInclude?.user || '-'}</p>
          <p className="bold mb0">Data: {moment(typeInclude?.date)?.format("DD/MM/YYYY")} - {moment(typeInclude?.date)?.format('HH:mm')} hs</p>
          ---------------------------------------------
          <p className="bold mb0">ALTERADO NA PRODUÇÃO:</p>
          <p className="bold mb0">Qtde: {typeStart?.quantity?.toLocaleString('pt-br', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            })} {manufacture?.un?.abbreviation}</p>
          <p className="bold mb0">Rendimento: {typeStart?.yield?.toLocaleString('pt-br', {
              minimumFractionDigits: 3,
              maximumFractionDigits: 3
            })} {manufacture?.un?.abbreviation}</p>
          <p className="bold mb0">Usuário: {typeStart?.user || '-'}</p>
          <p className="bold mb0">Data: {moment(typeStart?.date)?.format("DD/MM/YYYY")} - {moment(typeStart?.date)?.format('HH:mm')} hs</p>
        </div>
      }
      aria-label="filters"
      placement="right-start"
    >
      <img 
        src={OutProgrammingChangedProduction}
        style={{ width: 16, height: 15 }}
      />
    </Tooltip>
    }
  }

  const renderCardDescriptionInfos = (currentManufacture, type, handlePreparationClick) => (
    <div className="dFlex alignCenter w100">
      <div
        style={{ padding: '0 5px 0 0' }}
        onClick={() => handleOpenItems(currentManufacture._id)}
      >
        {manufactures.find((el) => el._id === currentManufacture._id)
          ?.open ? (
          <ExpandLess style={{ marginLeft: "-6px" }} />
        ) : (
          <ExpandMore style={{ marginLeft: "-6px" }} />
        )}
      </div>

      <div
        className="justifyBetween dFlex"
        style={{ padding: '0', width: "250px" }}
        onClick={() => {
          if (currentManufacture?.preparationMethod?.url) return;
          handleOpenItems(currentManufacture._id);
        }}
      >
        <div className="dFlex alignCenter w100">
          <Tooltip
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            placement="right"
            title={
              <span
                className="dBlock"
                style={{ padding: '4px 7px' }}
              >
                {currentManufacture?.cardId} -{' '}
                {handleFields(currentManufacture).description}
              </span>
            }
          >
            <Link
              to={`/preparation/${currentManufacture?.preparationMethod?.name}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mr10"
              style={{ width: "89.5%" }}
              onClick={(e) => {
                if (!currentManufacture?.preparationMethod?.url) {
                  e.preventDefault()
                }
              }}
            >
              <span
                style={{
                  color: currentManufacture?.preparationMethod?.url
                    ? '#5062F0'
                    : '#0F1225'
                }}
                onClick={() => {
                  if (!currentManufacture?.preparationMethod?.url) return;

                  handlePreparationClick(
                    currentManufacture?.preparationMethod?.url
                  )
                }}
              >
                {handleFields(currentManufacture).description?.length > 30
                  ? `${handleFields(
                      currentManufacture
                    ).description?.substring(0, 27)}`
                  : handleFields(currentManufacture).description
                }

                {handleFields(currentManufacture).description?.length > 30 && '...'}
              </span>
            </Link>
          </Tooltip>
        </div>
      </div>

      <div className="dFlex justifyCenter alignCenter" style={{ width: "30px" }}>
        {type === 'recipe' &&
          <ImageWrapper
            width="30px"
            height="28px"
            url={currentManufacture?.image}
            borderType="INTERNAL"
          />
        }
      </div>

      <div className="dFlex justifyEnd" style={{ width: "80px", height: '100%' }}>
        <span className="dFlex alignCenter">
          {Array.isArray(companiesActive.id) ? (
            <Tooltip
              title={
                <p style={{ padding: '3px 8px', margin: 0 }}>
                  <b>{getRestaurantbyId(currentManufacture?.restaurantId, companies)?.name}</b>
                </p>
              }
              aria-label="filters"
              placement="right-start"
            >
              <img
                src={storeIconWS}
                style={{ width: 16, height: 15, marginLeft: '8px' }}
              />
            </Tooltip>
          ) : null}
        </span>
      </div>

      <div className="dFlex alignCenter justifyEnd" style={{ width: "43px" }}>
        {/* {currentManufacture?.origin === "M" 
          ? renderManualProductionIcon(currentManufacture)
          : renderEngineProductionIcon(currentManufacture)
        } */}
        
        {renderIcon(currentManufacture)}
      </div>
    </div>
  )

  const renderItemTransformationInfos = (currentManufacture, itemTransformation, index) => (
    <div className="dFlex alignCenter w100" style={{ paddingLeft: 23 }}>
      <div className="justifyBetween dFlex" style={{ width: "250px" }}>
        <Tooltip
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}
          placement="right"
          title={
            <span
              className="dBlock"
              style={{ padding: '4px 7px' }}
            >
              Produto à ser transformado
            </span>
          }
        >
          <span
            style={{
              color: currentManufacture?.preparationMethod?.url
                ? '#5062F0'
                : '#0F1225'
            }}
          >
            {ValidationLength(
              handleFields(itemTransformation).onlyDescription, 30
            )}
          </span>
        </Tooltip>
      </div>

      <div className="dFlex justifyCenter alignCenter" style={{ width: "30px" }}>
        <ImageWrapper
          width="30px"
          height="28px"
          url={itemTransformation?.image?.url}
          borderType={itemTransformation?.type}
        />
      </div>
      
      <div className="ml10" style={{ width: "90px" }}>
        <InputNumber
          updateQuantityInitialValue={updateQuantityInitialValue}
          setModalStates={setModalStates}
          modalStates={modalStates}
          setUpdateValue={setUpdateValue}
          updateValue={updateValue}
          disabled={
            currentManufacture?.status !== 'WAITING' && currentManufacture?.status !== 'START' && currentManufacture?.status !== 'PAUSE'
          }
          minimumValue="0"
          maximumValue="999999999"
          initialValue={currentManufacture?.quantity?.toFixed(3)}
          // validUnit={manufacture?.un?.abbreviation === 'un'}
          handleValue={(value) => {
            setManufacture(currentManufacture);

            handleCardQuantity(
              index,
              parseFloat(value),
              undefined,
              undefined,
              undefined
            );
          }}
          fontSize="12px"
          fontWeight="normal"
          width="100%"
          height="28px"
        />
      </div>

      <span className="ml3 dFlex justifyEnd" style={{ width: "20px", paddingRight: 1 }}>
        {itemTransformation?.consumptionUnits?.abbreviation || ''}
      </span>
    </div>
  )

  const renderCardStock = (currentManufacture, itemTransformation) => (
    <div className="dFlex justifyEnd w100">
      {itemTransformation
        ? handleFields(itemTransformation)?.theoreticalStock
        : handleFields(currentManufacture)?.stock}

      <span className="ml3">
        {currentManufacture.type === 'TRANSFORMATION'
          ? currentManufacture?.items?.[0]?.un?.abbreviation || ''
          : currentManufacture?.un?.abbreviation || ''
        }
      </span>
    </div>
  )

  const renderCardDuration = (currentManufacture, disabled, itemTransformation) => (
    <span
      className={`lightBlue w100 ${disabled ? 'cursorAuto' : 'cursorPointer'}`}
      onClick={() => {
        if (disabled) return null

        getDuration(
          currentManufacture.productId ? currentManufacture.productId : null,
          itemTransformation ? itemTransformation?.theoreticalStock : currentManufacture.stock,
          currentManufacture
        );
        handleClickOpenModal(currentManufacture);
      }}
    >
      {handleFields(itemTransformation || currentManufacture).duration}
    </span>
  )

  const renderRecipeProductionInput = (currentManufacture, index) => (
    currentManufacture?.viewMethod === 1 ?
      <InputNumber
        updateQuantityInitialValue={updateQuantityInitialValue}
        setModalStates={setModalStates}
        modalStates={modalStates}
        setUpdateValue={setUpdateValue}
        updateValue={updateValue}
        disabled={
          currentManufacture?.status !== 'WAITING' && currentManufacture?.status !== 'START' && currentManufacture?.status !== 'PAUSE'
        }
        minimumValue="0"
        maximumValue="999999999"
        initialValue={currentManufacture?.quantity?.toFixed(3)}
        // validUnit={manufacture?.un?.abbreviation === 'un'}
        handleValue={(value) => {
          setManufacture(currentManufacture);

          handleCardQuantity(
            index,
            parseFloat(value),
            undefined,
            undefined,
            undefined
          );
        }}
        fontSize="12px"
        fontWeight="normal"
        width="100%"
        height="28px"
      />
    :
      <InputNumber
        updateQuantityInitialValue={updateQuantityInitialValue}
        setModalStates={setModalStates}
        modalStates={modalStates}
        setUpdateValue={setUpdateValue}
        updateValue={updateValue}
        disabled={
          currentManufacture?.status !== 'WAITING' &&
          currentManufacture?.status !== 'START' &&
          currentManufacture?.status !== 'PAUSE'
        }
        minimumValue="0"
        maximumValue="999999999"
        // validUnit={manufacture?.un?.abbreviation === 'un'}
        initialValue={currentManufacture?.yield?.toFixed(3)}
        handleValue={(value) => {
          setManufacture(currentManufacture);

          handleCardQuantity(
            index,
            currentManufacture?.quantity || 1,
            undefined,
            undefined,
            parseFloat(value)
          );
        }}
        fontSize="12px"
        fontWeight="normal"
        width="100%"
        height="28px"
      /> 
  )

  const renderCardProduction = (currentManufacture, type, index) => (
    <div className="dFlex w100">
      {type === 'TRANSFORMATION'
      ?
        <span 
          className="dFlex justifyEnd" 
          style={{ 
            width: '32%', 
            color: currentManufacture?.loss ? "red" : '#1F2445'
          }}
        >
          {currentManufacture?.loss
            ? `-${parseFloat(currentManufacture?.loss).toLocaleString('pt-br', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}%`
            : '0,00%'
          }
        </span>
      :
        <span 
          className="dFlex justifyEnd bold lightBlue cursorPointer" 
          style={{ width: '32%' }}
          onClick={(event) => {
            setProductionInputControlAnchor(event.currentTarget)
            setCurrentCard(currentManufacture)
          }}
        >
          {currentManufacture?.viewMethod === 1 ? 'Receitas' : 'Rend.'}
        </span>
      }

      <div className={`${currentManufacture?.status !== 'WAITING' && currentManufacture?.status !== 'START' && currentManufacture?.status !== 'PAUSE' && 'disabledField'}`} style={{ width: "48%", margin: '0 5px' }}>
        {type === 'TRANSFORMATION' ?
          <InputNumber
            updateQuantityInitialValue={updateQuantityInitialValue}
            setModalStates={setModalStates}
            modalStates={modalStates}
            setUpdateValue={setUpdateValue}
            updateValue={updateValue}
            disabled={
              currentManufacture?.status !== 'WAITING' &&
              currentManufacture?.status !== 'START' &&
              currentManufacture?.status !== 'PAUSE'
            }
            minimumValue="0"
            maximumValue="999999999"
            // validUnit={manufacture?.un?.abbreviation === 'un'}
            initialValue={currentManufacture?.yield?.toFixed(3)}
            handleValue={(value) => {
              setManufacture(currentManufacture);

              handleCardQuantity(
                index,
                currentManufacture?.quantity || 1,
                undefined,
                undefined,
                parseFloat(value)
              );
            }}
            fontSize="12px"
            fontWeight="normal"
            width="100%"
            height="28px"
          /> 
        :
          renderRecipeProductionInput(currentManufacture, index)
        }
      </div>
      
      <span className="dFlex" style={{ width: "20%" }}>
        {type === 'TRANSFORMATION'
          ? currentManufacture?.items?.[0]?.un?.abbreviation || ''
          : currentManufacture?.viewMethod !== 1 ? currentManufacture?.un?.abbreviation : ''
        }
      </span>
    </div>
  )

  function handleRecipe(manufacture, open, cardIndex) {
    return (
      <tr>
        <td>
          <Collapse
            in={open}
            timeout="0"
            unmountOnExit
            className={open && 'expanded'}
          >
            &nbsp;
          </Collapse>
        </td>

        <td colSpan="8" className="tableColorHover">
          <Collapse
            in={open}
            timeout="0"
            unmountOnExit
            className={open && 'expanded'}
          >
            <table
              cellPadding="0"
              cellSpacing="0"
              border="0"
              style={{ width: "100%", border: 'solid 1px #1F2445', borderBottom: 'none', background: 'rgba(242, 243, 248, .8)' }}
              className="dropDownTable"
            >
              <colgroup>
                <col style={{ width: isLargeScreen ? '28.02%' : '29.98%' }} />
                <col style={{ width: isLargeScreen ? '7.15%' : '6.95%' }} />
                <col style={{ width: isLargeScreen ? '6.12%' : '6.05%' }} />
                <col style={{ width: isLargeScreen ? '13.25%' : '12.75%' }} />
                <col style={{ width: isLargeScreen ? '9.18%' : '8.86%' }} />
                <col style={{ width: isLargeScreen ? '9.18%' : '8.85%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '16%' }} />
              </colgroup>

              <tbody>
                {manufacture.items?.map((item, index) => {
                  const isLastElement = index === manufacture.items?.length - 1; 
                  const handleItemQuantity = (value, labelQuantity = '') => {
                    if (!value) {
                      return;
                    }

                    setManufacture(manufacture);

                    handleCardQuantity(
                      cardIndex,
                      manufacture.quantity,
                      index,
                      parseFloat(value),
                      undefined,
                      true,
                      labelQuantity
                    );
                  };

                  const exists = cards[cardIndex].items ? item : null;

                  if (
                    cards[cardIndex].items.length < manufacture.items.length &&
                    !exists
                  ) {
                    cards[cardIndex].items.push({
                      id: index,
                      quantity: item.quantity,
                      initialQuantity: item.quantity,
                      discard: { quantity: 0, reason: null }
                    });
                  }

                  const discardReason = item?.discard?.length
                    ? capitalize(
                        item?.discard[0]?.justification?.description
                      ) || ''
                    : capitalize(item?.discard?.justification?.description) ||
                      '';

                  return (
                    <>
                      <tr>
                        <td
                          className={`description itemProductionTableDescription ${index === 0 ? 'pt5' : 'pt3'} ${item?.main && 'productMain'}`}
                          style={{ paddingLeft: '22px' }}
                        >
                          <div className={`dFlex alignCenter ${isLastElement ? 'pb5' : 'pb3'}`}>
                            <div className="dFlex" style={{ width: "250px" }}>
                              {ValidationLength(
                                item.item, 
                                28, 
                                null, 
                                null, 
                                null, 
                                null, 
                                item?.itemProcess?.description ? `- ${item?.itemProcess?.description}` : '',
                              )}
                            </div>

                            <div className="dFlex alignCenter justifyCenter" style={{ width: "30px" }}>
                              <ImageWrapper
                                width="30px"
                                height="28px"
                                url={item?.image}
                                borderType={item?.type}
                              />
                            </div>
                            
                            <div className="dFlex ml10" style={{ width: "90px" }} >
                              {manufacture.status !== 'WAITING' ? (
                                <span>
                                  {item.quantity ? (
                                    parseFloat(item.quantity).toLocaleString('pt-br', {
                                      minimumFractionDigits: 3
                                    })
                                  ) : (
                                    '0,000'
                                  )}
                                </span>
                              ) : (
                                <>
                                  <InputNumber
                                    updateQuantityInitialValue={updateQuantityInitialValue}
                                    setModalStates={setModalStates}
                                    modalStates={modalStates}
                                    setUpdateValue={setUpdateValue}
                                    updateValue={updateValue}
                                    disabled={
                                      manufacture?.status !== 'WAITING' &&
                                      manufacture?.status !== 'START' &&
                                      manufacture?.status !== 'PAUSE'
                                    }
                                    initialValue={item.quantity}
                                    // validUnit={item?.un?.abbreviation === 'un'}
                                    handleValue={handleItemQuantity}
                                    fontSize="12px"
                                    fontWeight="normal"
                                    width="100%"
                                  />
                                  {/* {(item.initialQuantity
                                      ? item.quantity == 0
                                      : item.quantity * manufacture.quantity == 0
                                    ) &&
                                      <p className="requiredWarning">
                                        Não pode ser 0
                                      </p>
                                    } */}
                                </>
                              )}
                            </div>

                            <span className="dFlex alignCenter ml5 pl5" style={{ width: "20px" }}>
                              {item?.un?.abbreviation}
                            </span>
                          </div>
                        </td>

                        <td className="description right" style={{ borderLeft: 'solid 1px rgba(208, 211, 226, .5)' }}>
                          <div className={`${isLastElement ? 'pb5' : 'pb3'} pr8 dFlex justifyEnd`}>
                            {`${
                              (item?.stock || 0)?.toLocaleString('pt-br', {
                                minimumFractionDigits: 3
                              })
                            }`}

                            <span className="ml3 dFlex alignCenter justifyCenter" style={{ width: "13%" }}>
                              {item?.un?.abbreviation || ''}
                            </span>
                          </div>
                        </td>

                        <td style={{ borderLeft: 'solid 1px rgba(208, 211, 226, .5)' }}>
                          <div className={`${isLastElement ? 'pb5' : 'pb3'}`}/>
                        </td>

                        <td style={{ borderLeft: 'solid 1px rgba(69, 74, 103, .5)' }}>
                          <div className={`${isLastElement ? 'pb5' : 'pb3'}`}/>
                        </td>

                        <td style={{ borderLeft: 'solid 1px rgba(208, 211, 226, .5)' }}>
                          <div className={`${isLastElement ? 'pb5' : 'pb3'}`}/>
                        </td>

                        <td>
                          <div className={`${isLastElement ? 'pb5' : 'pb3'}`}/>
                        </td>

                        <td className={`description right ${index === 0 ? 'pt5' : 'pt3'}`} style={{ borderLeft: 'solid 1px rgba(69, 74, 103, .5)' }}>
                          <div className={`dFlex alignCenter ${isLastElement ? 'pb5' : 'pb3'} pr8 pl12`}>
                            <Tooltip
                              title="Lançar Descarte de Produto"
                              placement="bottom"
                            >
                              <div>
                                <CurrencyTextField
                                  margin="none"
                                  variant="standard"
                                  size="small"
                                  currencySymbol=""
                                  minimumValue="0"
                                  maximumValue="999999999"
                                  outputFormat="string"
                                  decimalCharacter=","
                                  digitGroupSeparator="."
                                  decimalPlaces={3}
                                  decimalPlacesShownOnBlur={3}
                                  decimalPlacesShownOnFocus={3}
                                  disabled={
                                    manufacture?.status !== 'WAITING' &&
                                    manufacture?.status !== 'START' &&
                                    manufacture?.status !== 'PAUSE'
                                  }
                                  type="text"
                                  name="quantity"
                                  fullWidth
                                  value={
                                    item?.discard?.length
                                      ? item?.discard[0]?.quantity || ''
                                      : item?.discard?.quantity || ''
                                  }
                                  style={{ width: '100%' }}
                                  InputProps={{
                                    maxLength: 8,
                                    classes: { input: classes.input }
                                  }}
                                  onBlur={(_, value) => {
                                    handleItemDiscard(
                                      manufacture._id,
                                      index,
                                      value,
                                      discardReason,
                                      discardReason && value,
                                      item
                                    );
                                  }}
                                />
                              </div>
                            </Tooltip>

                            <span className="dFlex alignCenter justifyCenter ml3">
                              {item?.un?.abbreviation}
                            </span>
                          </div>
                        </td>

                        <td className={`description ${index === 0 ? 'pt5' : 'pt3'}`} style={{ paddingRight: '12px' }}>
                          <div className={`dFlex alignCenter ${isLastElement ? 'pb5' : 'pb3'}`}>
                            <Autocomplete
                              size="small"
                              classes={{
                                inputRoot: classes.inputRoot,
                                option: classes.option
                              }}
                              id="asynchronous-demo"
                              className="autocompleteSmall autocompletePtChild0 w100"
                              onChange={(option, value) => {
                                if (value) {
                                  handleItemDiscard(
                                    manufacture._id,
                                    index,
                                    item?.discard?.length
                                      ? item?.discard[0]?.quantity
                                      : item?.discard?.quantity,
                                    value,
                                    (item?.discard?.length
                                      ? item?.discard[0]?.quantity
                                      : item?.discard?.quantity) && value,
                                    item
                                  );
                                } else {
                                  handleItemDiscard(
                                    manufacture._id,
                                    index,
                                    item?.discard?.length
                                      ? item?.discard[0]?.quantity
                                      : item?.discard?.quantity,
                                    '',
                                    false,
                                    item
                                  );
                                }
                              }}
                              getOptionLabel={(option) => option.description}
                              options={optionsDiscard.map((option) => ({
                                ...option,
                                description: capitalize(option?.description)
                              }))}
                              value={
                                optionsDiscard
                                  .map((option) => ({
                                    ...option,
                                    description: capitalize(option?.description)
                                  }))
                                  .filter(
                                    (option) => option.description === discardReason
                                  )[0]
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  required
                                  style={{ width: '100%', height: 20 }}
                                  placeholder="Justifique..."
                                  InputLabelProps={{
                                    style: { fontFamily: 'Lato', fontSize: '12px' }
                                  }}
                                />
                              )}
                            />

                            {(item?.discard?.length
                              ? item?.discard[0]?.quantity || 0
                              : item?.discard?.quantity || 0) !== 0 &&
                              !discardReason &&
                              <Tooltip
                                title="Preencha este campo."
                                placement="bottom"
                                open={
                                  (item?.discard?.length
                                    ? item?.discard[0]?.quantity || 0
                                    : item?.discard?.quantity || 0) !== 0 &&
                                  !discardReason
                                }
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                arrow
                              >
                                <p className="m0 w100 pAbsolute" />
                              </Tooltip>
                            }
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan="10" className={`${isLastElement && 'dNone'}`} style={{ padding: '0 12px 0 20px' }}>
                          <hr style={{ backgroundColor: 'rgba(69, 74, 103, 1)' }} />
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </Collapse>
        </td>

        <td>
          <Collapse
            in={open}
            timeout="0"
            unmountOnExit
            className={open && 'expanded'}
          >
            &nbsp;
          </Collapse>
        </td>
      </tr>
    );
  }

  function handleTransformation(manufacture, open, cardIndex) {
    const cardYield =
      manufacture.type === 'recipe'
        ? manufacture?.yield * (manufacture.quantity || 1)
        : (manufacture.quantity || 1) -
          (manufacture.quantity || 1) * (manufacture.loss / 100);
    const { loss } = manufacture;
    const total = manufacture.items.reduce(
      (total, value) =>
        value
          ? parseFloat(total) + parseFloat(value.quantity)
          : parseFloat(total),
      0
    );
    const cardQuantity = manufacture.quantity || 1;
    const cardLostTotal = parseFloat(cardQuantity) - parseFloat(total);
    const disableDurationDialog = checkIsBefore(moment(manufacture?.date).add(3, "hours").format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
    
    return (
      <tr valign="center">
        <td>
          <Collapse
            in={open}
            timeout="0"
            unmountOnExit
            className={open && 'expanded'}
          >
            &nbsp;
          </Collapse>
        </td>

        <td colSpan="8" className="tableColorHover">
          <Collapse
            in={open}
            timeout="0"
            unmountOnExit
            className={open && 'expanded'}
          >
            <table
              cellPadding="0"
              cellSpacing="0"
              border="0"
              style={{ width: "100%", border: 'solid 1px #1F2445', borderBottom: 'none', background: 'rgba(242, 243, 248, .8)' }}
              className="dropDownTable"
            >
              <colgroup>
                <col style={{ width: isLargeScreen ? '28.02%' : '29.98%' }} />
                <col style={{ width: isLargeScreen ? '7.15%' : '6.95%' }} />
                <col style={{ width: isLargeScreen ? '6.12%' : '6.05%' }} />
                <col style={{ width: isLargeScreen ? '13.25%' : '12.75%' }} />
                <col style={{ width: isLargeScreen ? '9.18%' : '8.86%' }} />
                <col style={{ width: isLargeScreen ? '9.18%' : '8.85%' }} />
                <col style={{ width: '11%' }} />
                <col style={{ width: '16%' }} />
              </colgroup>

              <tbody>
                {manufacture.items.map((item, index) => {
                  const isLastElement = index === manufacture.items?.length - 1; 
                  const exists = cards[cardIndex].items ? item : null;

                  if (
                    cards[cardIndex].items.length < manufacture.items.length &&
                    !exists
                  ) {
                    cards[cardIndex].items.push({
                      id: index,
                      quantity: item.quantity,
                      initialQuantity: item.quantity,
                      discard: {
                        quantity: 0,
                        reason: {
                          id: null,
                          description: null
                        }
                      }
                    });
                  }

                  const discardReason = item?.discard?.length
                    ? capitalize(
                        item?.discard[0]?.justification?.description
                      ) || ''
                    : capitalize(item?.discard?.justification?.description) ||
                      '';

                  return (
                    <>
                      <tr>
                        <td
                          className={`description ${index === 0 ? 'pt5' : 'pt3'} ${item?.main && 'productMain'}`}
                          style={{ paddingLeft: '22px' }}
                        >
                          <div className="dFlex alignCenter">
                            <div className="dFlex alignCenter" style={{ width: "250px" }}>
                              {ValidationLength(item.item, 23)}

                              {item.suggestionYield
                              ? `(${
                                  item.suggestionYield.toLocaleString('pt-br', {
                                    minimumFractionDigits: 3
                                  }) + (item?.un?.abbreviation || '')
                                })`
                              : ''}
                            </div>

                            <div className="dFlex alignCenter justifyCenter" style={{ width: "30px" }}>
                              <ImageWrapper
                                width="30px"
                                height="28px"
                                url={item?.image}
                                borderType={item?.type}
                              />
                            </div>
                          </div>
                        </td>

                        <td className="description right" style={{ borderLeft: 'solid 1px rgba(208, 211, 226, .5)' }}>
                          <div className={`${isLastElement ? 'pb5' : 'pb3'} pr8 dFlex justifyEnd`}>
                            {`${
                              (item?.stock || 0)?.toLocaleString('pt-br', {
                                minimumFractionDigits: 3
                              })
                            }`}

                            <span className="ml3 dFlex alignCenter justifyCenter" style={{ width: "13%" }}>
                              {item?.un?.abbreviation || ''}
                            </span>
                          </div>
                        </td>

                        <td className="description pr10" style={{ borderLeft: 'solid 1px rgba(208, 211, 226, .5)' }}>
                          <span
                            className={`lightBlue ${disableDurationDialog ? 'cursorAuto' : 'cursorPointer'} dBlock w100 textAlignRight`}
                            onClick={() => {
                              if (disableDurationDialog) return null
                              
                              getDuration(
                                item.id ? item.id : null,
                                item.stock,
                                item
                              );
                              handleClickOpenModal(manufacture);
                            }}
                          >
                            {`${item.duration ? item.duration : 0} ${
                              item.duration > 1 ? 'dias' : 'dia'
                            }`}
                          </span>
                        </td>

                        <td className="description p8" style={{ borderLeft: 'solid 1px rgba(69, 74, 103, .5)', verticalAlign: 'middle' }}>
                          <div className={`dFlex alignCenter ${isLastElement ? 'pb5' : 'pb0'}`}>
                            <div style={{ width: '33%' }}/>

                            <div className="dFlex alignCenter justifyEnd" style={{ width: "45%" }}>
                              {manufacture.status !== 'WAITING' ? (
                                item.quantity ? (
                                    parseFloat(item.quantity).toLocaleString(
                                      'pt-br',
                                      { minimumFractionDigits: 3 }
                                    )
                                ) : (
                                  '0,000'
                                )
                              ) : (
                                <InputNumber
                                  updateQuantityInitialValue={updateQuantityInitialValue}
                                  setModalStates={setModalStates}
                                  modalStates={modalStates}
                                  setUpdateValue={setUpdateValue}
                                  updateValue={updateValue}
                                  disabled={
                                    manufacture?.status !== 'WAITING' &&
                                    manufacture?.status !== 'START' &&
                                    manufacture?.status !== 'PAUSE'
                                  }
                                  minimumValue="0"
                                  maximumValue="999999999"
                                  initialValue={item?.quantity?.toFixed(3)}
                                  handleValue={(value) => {
                                    if (
                                      !updateValue &&
                                      parseFloat(item.quantity).toFixed(3) ===
                                        parseFloat(value).toFixed(3)
                                    )
                                      return;

                                    handleCardQuantity(
                                      cardIndex,
                                      manufacture.quantity,
                                      index,
                                      parseFloat(value),
                                      undefined
                                    );
                                    setUpdateValue(false);
                                  }}
                                  fontSize="12px"
                                  fontWeight="normal"
                                  width="100%"
                                  height="28px"
                                />
                              )}
                            </div>
                            
                            <span className="ml5 dFlex alignCenter"> 
                              {item?.un?.abbreviation}
                            </span>
                          </div>
                        </td>

                        <td style={{ borderLeft: 'solid 1px rgba(208, 211, 226, .5)' }}>
                          &nbsp;
                        </td>

                        <td className="description right p8">
                          &nbsp;
                        </td>

                        <td className={`description right ${index === 0 ? 'pt5' : 'pt3'}`} style={{ borderLeft: 'solid 1px rgba(69, 74, 103, .5)' }}>
                          <div className={`dFlex alignCenter ${isLastElement ? 'pb5' : 'pb3'} pr8 pl12`}>
                            <Tooltip
                              title="Lançar Descarte de Produto"
                              placement="bottom"
                            >
                              <div>
                                <CurrencyTextField
                                  margin="none"
                                  variant="standard"
                                  size="small"
                                  currencySymbol=""
                                  minimumValue="0"
                                  maximumValue="999999999"
                                  outputFormat="string"
                                  decimalCharacter=","
                                  digitGroupSeparator="."
                                  decimalPlaces={3}
                                  decimalPlacesShownOnBlur={3}
                                  decimalPlacesShownOnFocus={3}
                                  type="text"
                                  name="quantity"
                                  fullWidth
                                  value={
                                    item?.discard?.length
                                      ? item?.discard[0]?.quantity || ''
                                      : item?.discard?.quantity || ''
                                  }
                                  style={{ width: '100%' }}
                                  InputProps={{
                                    maxLength: 8,
                                    classes: { input: classes.input }
                                  }}
                                  onBlur={(_, value) => {
                                    handleItemDiscard(
                                      manufacture._id,
                                      index,
                                      value,
                                      discardReason,
                                      discardReason && value,
                                      item
                                    );
                                  }}
                                />
                              </div>
                            </Tooltip>

                            <span className="dFlex alignCenter justifyCenter ml3">
                              {item?.un?.abbreviation}
                            </span>
                          </div>
                        </td>

                        <td className={`description ${index === 0 ? 'pt5' : 'pt3'}`} style={{ paddingRight: '12px' }}>
                          <div className={`dFlex alignCenter ${isLastElement ? 'pb5' : 'pb3'}`}>
                            <Autocomplete
                              size="small"
                              classes={{
                                inputRoot: classes.inputRoot,
                                option: classes.option
                              }}
                              id="asynchronous-demo"
                              className="autocompleteSmall autocompletePtChild0 w100"
                              onChange={(option, value) => {
                                if (value) {
                                  handleItemDiscard(
                                    manufacture._id,
                                    index,
                                    item?.discard?.length
                                      ? item?.discard[0]?.quantity
                                      : item?.discard?.quantity,
                                    value,
                                    (item?.discard?.length
                                      ? item?.discard[0]?.quantity
                                      : item?.discard?.quantity) && value,
                                    item
                                  );
                                } else {
                                  handleItemDiscard(
                                    manufacture._id,
                                    index,
                                    item?.discard?.length
                                      ? item?.discard[0]?.quantity
                                      : item?.discard?.quantity,
                                    '',
                                    false,
                                    item
                                  );
                                }
                              }}
                              getOptionLabel={(option) => option.description}
                              options={optionsDiscard.map((option) => ({
                                ...option,
                                description: capitalize(option?.description)
                              }))}
                              value={
                                optionsDiscard
                                  .map((option) => ({
                                    ...option,
                                    description: capitalize(option?.description)
                                  }))
                                  .filter(
                                    (option) =>
                                      option.description === discardReason
                                  )[0]
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  required
                                  margin="none"
                                  style={{ width: '100%', height: 20 }}
                                  placeholder="Justifique..."
                                  InputLabelProps={{
                                    style: {
                                      fontFamily: 'Lato',
                                      fontSize: '12px'
                                    }
                                  }}
                                />
                              )}
                            />

                            {(item?.discard?.length
                              ? item?.discard[0]?.quantity || 0
                              : item?.discard?.quantity || 0) !== 0 &&
                            !discardReason &&
                              <Tooltip
                                title="Preencha este campo."
                                open={
                                  (item?.discard?.length
                                    ? item?.discard[0]?.quantity || 0
                                    : item?.discard?.quantity || 0) !== 0 &&
                                  !discardReason
                                }
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                placement="bottom"
                                arrow
                              >
                                <p className="m0 w100 pAbsolute" />
                              </Tooltip>
                            }
                          </div>
                        </td>

                        {/* <td
                          className="description"
                          colSpan="3"
                          style={{
                            color:
                              parseFloat(100 * cardLostTotal) /
                                parseFloat(cardQuantity) >
                              parseFloat(loss)
                                ? 'red'
                                : 'black'
                          }}
                        >
                          {total !== 0 &&
                            `${(
                              parseFloat(100 * cardLostTotal) /
                              parseFloat(cardQuantity)
                            ).toLocaleString('pt-br', {
                              minimumFractionDigits: 3
                            })}%`
                          }
                        </td> */}
                      </tr>

                      <tr>
                        <td colSpan="8">
                          <hr />
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </Collapse>
        </td>

        <td>
          <Collapse
            in={open}
            timeout="0"
            unmountOnExit
            className={open && 'expanded'}
          >
            &nbsp;
          </Collapse>
        </td>
      </tr>
    );
  }

  if (!manufactures) {
    return (
      <>
        <tr>
          <td colSpan="8" valign="center" align="center">
            {loading ? (
              <Typography
                style={{
                  verticalAlign: 'center',
                  margin: '10px 0'
                }}
              >
                <LinearProgress variant="query" />
              </Typography>
            ) : (
              <Typography
                style={{
                  verticalAlign: 'center',
                  margin: '10px 0'
                }}
              >
                Não há nada para ser exibido
              </Typography>
            )}
          </td>
        </tr>

        <tr>
          <td colSpan="8">
            <hr />
          </td>
        </tr>
      </>
    );
  }
  
  return manufactures.map((manufacture, index) => {
    const type = manufacture?.type?.toLowerCase();
    const status = manufacture?.status?.toLowerCase();
    const lossManufactured = handleFields(manufacture).lossManufactured;
    const lossManufacturedMonetary = handleFields(manufacture).lossManufacturedMonetary;
    const hideManufacturedAndDiffInfos = handleFields(manufacture).manufactured === null || handleFields(manufacture).manufactured === '' || status !== 'finish'
    const isTransformation = manufacture?.type === 'TRANSFORMATION'
    const isPrintEnabled = parametersInfos?.manufactures?.isPrintEnabled && manufacture?.status !== "CANCELED"
    const haveSomePrintLabel = isTransformation 
      ? manufacture?.items?.map(item => item?.portions?.some(portion => portion?.printed)).flat()?.some(el => el)
      : manufacture?.portions?.some(el => el?.printed)
    
    const isIncluded = manufacture?.status?.toUpperCase() === 'WAITING'
    const isToProduce = manufacture?.statusAction?.toUpperCase() === 'TO_PRODUCE'
    const isCanceled = manufacture?.status?.toUpperCase() === 'CANCELED'
    const isFinished = manufacture?.status?.toUpperCase() === 'FINISH'

    const actionIncluded = manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'TO_PRODUCE') || manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'INCLUDE') || null
    const actionToProduce = isToProduce ? manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'TO_PRODUCE') : null
    const actionStarted = manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'START') || null
    const actionPaused = manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'PAUSE') || null
    const actionRestarted = manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'RESTART') || null
    const actionFinished = manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'FINISH') || null
    const actionCanceled = manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'CANCELED') || null

    const inclusion = manufacture?.dateAction ? moment(manufacture?.dateAction) : moment(manufacture?.created_at).add(3, 'hour')
    const hourInclusion = moment(inclusion).format('LT');
    const dateInclusion = moment(inclusion).format('DD/MM/YYYY');
    const userInclusion = actionToProduce ? actionToProduce?.user : manufacture?.actions?.find(action => action?.type?.toUpperCase() === 'INCLUDE')?.user || ''

    let hourStart = actionStarted ? moment(actionStarted.date).format('LT') : null

    if (actionStarted && moment(actionStarted?.date).isBefore(moment(inclusion), 'hour')) {
      hourStart = moment(actionStarted.date).add(3, 'hour').format('LT')
    }

    const dateStart = actionStarted ? moment(actionStarted.date).format('DD/MM/YYYY') : null
    const userStart = actionStarted ? actionStarted?.user : null

    const hourFinished = actionFinished ? moment(actionFinished.date).format('LT') : null
    const dateFinished = actionFinished ? moment(actionFinished.date).format('DD/MM/YYYY') : null
    const userFinished = actionFinished?.user || null

    const hourPaused = actionPaused ? moment(actionPaused.date).format('LT') : null
    const datePaused = actionPaused ? moment(actionPaused.date).format('DD/MM/YYYY') : null
    const userPaused = actionPaused?.user || null

    const hourRestarted = actionRestarted ? moment(actionRestarted.date).format('LT') : null
    const dateRestarted = actionRestarted ? moment(actionRestarted.date).format('DD/MM/YYYY') : null
    const userRestarted = actionRestarted?.user || null

    const hourCanceled = actionCanceled ? moment(actionCanceled.date).format('LT') : null
    const dateCanceled = actionCanceled ? moment(actionCanceled.date).format('DD/MM/YYYY') : null
    const userCanceled = actionCanceled?.user || null

    let statusColor = '';
    let statusBackground = '';
    let actionButton = null;
    let onClick = null;
    let tooltip = '';
    let duration = ''
    let diffHours = ''
    let diffMinutes = ''
    let action = null;
    let pluralText = '';
    let singularText = '';
    let statusText;
    const exists = cards ? cards.find((x) => x?.id === index) : null;
    const disableDurationDialog = checkIsBefore(moment(manufacture?.date).add(3, "hours").format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))

    if (cards && cards.length < manufactures.length && !exists) {
      cards
        .sort((a, b) => (a.status > b.status ? -1 : 1))
        .push({
          id: index,
          open: false,
          quantity: manufacture.quantity,
          type,
          startTime: manufacture.actions.reverse().find((x) => x.type === 'START')
            ? manufacture.actions.reverse().find((x) => x.type === 'START').date
            : null,
          pauseTime: manufacture.actions.reverse().find((x) => x.type === 'PAUSE')
            ? manufacture.actions.reverse().find((x) => x.type === 'PAUSE').date
            : null,
          finishTime: manufacture.actions.reverse().find((x) => x.type === 'FINISH')
            ? manufacture.actions.reverse().find((x) => x.type === 'FINISH').date
            : null,
          manufactured: manufacture.manufactured,
          totalLoss: null,
          loss: manufacture.loss ? manufacture.loss : 0,
          totalYield:
            type === 'recipe'
              ? manufacture?.yield * (manufacture.quantity || 1)
              : (manufacture.quantity || 1) - (manufacture.quantity || 1) * (manufacture.loss / 100),
          initialYield:
            type === 'recipe'
              ? manufacture?.yield * 1
              : 1 - 1 * (manufacture.loss / 100),
          items: []
        });
    }

    switch (type) {
      case 'recipe':
        pluralText = 'Ingredientes';
        singularText = 'Ingrediente';
        break;
      case 'transformation':
        pluralText = 'Produtos';
        singularText = 'Produto';
        break;
      default:
        pluralText = 'Itens';
        singularText = 'Item';
        break;
    }

    const startTime = manufacture.actions.length
      ? manufacture.actions
          .filter((item) => item.type === 'START')
          .sort((a, b) => (a.date < b.date ? 1 : -1))[0]?.date || new Date()
      : new Date();
    const pauseTime = manufacture.actions.length
      ? manufacture.actions
          .filter((item) => item.type === 'PAUSE')
          .sort((a, b) => (a.date < b.date ? 1 : -1))[0]?.date || new Date()
      : new Date();
    const totalYield =
      cards && cards.find((item, cardIndex) => cardIndex === index)
        ? cards.find((item, cardIndex) => cardIndex === index).totalYield
        : manufacture.yield;
    const quantity =
      cards && cards.find((item, cardIndex) => cardIndex === index)
        ? cards.find((item, cardIndex) => cardIndex === index).quantity
          ? cards.find((item, cardIndex) => cardIndex === index).quantity
          : 1
        : 1;

    function getLatestStartSorted(items) {
      const starts = items.filter(i => i.type === 'START' && i.date);
      if (!starts.length) return null;
      starts.sort((a, b) => Date.parse(b.date) - Date.parse(a.date));
      return starts[0];
    }

    function isYesterday(isoString) {
      return moment(isoString).isSame(moment().subtract(1, 'day'), 'day');
    }

    const handleActionButton = (status, index, quantity, fakeReturn = false) => {
      switch (status) {
        case 'canceled':
          const dateFormatted = manufacture?.actions?.find(
            (action) => action?.type === 'CANCELED'
          )?.date
            ? new Date(
                manufacture?.actions?.find(
                  (action) => action?.type === 'CANCELED'
                )?.date
              )
            : new Date();
          tooltip = manufacture?.cancellationReason;
          statusText = 'Cancelado';
          actionButton = (
            <img src={CancelProduction} />
          );
          statusColor = '#660008';
          statusBackground = '#F7D4D7';
          statusText = (
            <p>
              <b>Cancelado</b>
              {` às ${format(dateFormatted, 'kk:mm')}
                    ${
                      manufacture.actions.find(
                        (action) => action.type === 'CANCELED'
                      )
                        ? `(${
                            manufacture.actions.find(
                              (action) => action.type === 'CANCELED'
                            )?.user
                          })`
                        : ''
                    }`}
            </p>
          );
          break;
        case 'waiting':
          if (quantity) {
            statusText = (
              <p>
                <b>Iniciar</b>
              </p>
            );
            statusColor = '#1F2445';
            statusBackground = '#E6E7F0';
            actionButton = <img src={PlayIcon} />;
            action = 'start';
            onClick = () => {
              setManufacture({
                ...manufacture,
                items: manufacture?.items?.map(el => ({
                  ...el,
                  portions: el?.portions?.map(portion => ({
                    ...portion,
                    description: el?.item
                  }))
                }))
              });
              setCurrentTransformationCardItems({
                ...manufacture,
                items: manufacture?.items?.map((el) => ({
                  ...el,
                  quantity: null
                }))
              });

              setTimeout(() => {
                handleUpdate(manufacture, 'START');
              }, 100);
            };
          } else {
            statusText = (
              <p>
                <b>Iniciar</b>
              </p>
            );
            statusColor = '#1F2445';
            statusBackground = '#E6E7F0';
            actionButton = <img src={PlayIcon} />;
            action = 'start';
            onClick = (e) => {
              const hashId = GenerateHashId()
              const manufacturePortions = isTransformation
                ? manufacture?.portions
                : manufacture?.portions?.length 
                  ? manufacture?.portions?.map(el => ({
                    ...el,
                    fakeKey: crypto.randomUUID(), 
                    id: hashId
                  })) 
                  : [{ quantity: null, labelQuantity: '', printed: false, id: hashId }]
                
              setManufacture({
                ...manufacture,
                portions: manufacturePortions,
                items: manufacture?.items?.map(el => ({
                  ...el,
                  portions: el?.portions?.map(portion => ({
                    ...portion,
                    description: el?.item
                  }))
                }))
                
              });
              setCurrentTransformationCardItems({
                ...manufacture,
                items: manufacture?.items?.map((el) => ({
                  ...el,
                  quantity: null
                }))
              });
              setCardDate(manufacture.date);
              setPopoverData(
                <Grid
                  container
                  xs={12}
                  justify="center"
                  spacing={1}
                  style={{ padding: '10px', margin: 0 }}
                >
                  <Grid item xs={12}>
                    <Typography className="bold textAlignCenter">
                      Necessário preencher a quantidade
                    </Typography>
                  </Grid>
                </Grid>
              );

              handlePopoverClick(e);
            };
          }

          break;
        case 'start':
          statusText = (
            <p>
              <b>Produzindo...</b>
              {` Iniciado às ${hourStart} ${
                manufacture.actions.find((action) => action.type === 'START')
                  ? `(${
                      manufacture.actions.find(
                        (action) => action.type === 'START'
                      )?.user
                    })`
                  : ''
              }`}
            </p>
          );
          statusColor = '#0E1337';
          statusBackground = '#DADDF3';
          actionButton = <img src={ProductionIcon} />;
          manufacture.manufactured = null;
          onClick = (e) => {
            const hashId = GenerateHashId()
            const manufacturePortions = isTransformation
              ? manufacture?.portions
              : manufacture?.portions?.length 
                ? manufacture?.portions?.map(el => ({
                  ...el,
                  fakeKey: crypto.randomUUID(), 
                  id: hashId
                })) 
                : [{ quantity: null, labelQuantity: '', printed: false, id: hashId }]
            const latestStartAction = getLatestStartSorted(manufacture?.actions);
            const isStartedYesterday = isYesterday(latestStartAction?.date);
            const formattedDate = isStartedYesterday ? moment() : manufacture.date;

            setManufacture({
              ...manufacture,
              portions: manufacturePortions,
              items: manufacture?.items?.map(el => ({
                ...el,
                portions: el?.portions?.map(portion => ({
                  ...portion,
                  description: el?.item
                }))
              }))
            });
            setCurrentTransformationCardItems(manufacture);
            setCardDate(formattedDate);
            type === 'recipe'
            ? setPopoverData('start')
            : setPopoverData('finishTransformation');
            handlePopoverClick(e);
          };
          break;
        case 'pause':
          statusText = (
            <p>
              <b>Pausado...</b>
              {` às ${format(new Date(pauseTime), 'HH:mm')} ${
                manufacture.actions.find((action) => action.type === 'PAUSE')
                  ? `(${
                      manufacture.actions.find(
                        (action) => action.type === 'PAUSE'
                      )?.user
                    })`
                  : ''
              }`}
            </p>
          );
          statusColor = '#664C00';
          statusBackground = '#FFF2CC';
          actionButton = (
            <img src={PauseProductionIcon} />
          );
          onClick = (e) => {
            const hashId = GenerateHashId()
            const manufacturePortions = isTransformation
              ? manufacture?.portions
              : manufacture?.portions?.length 
                ? manufacture?.portions?.map(el => ({
                  ...el,
                  fakeKey: crypto.randomUUID(),
                  id: hashId
                })) 
                : [{ quantity: null, labelQuantity: '', printed: false, id: hashId }]

            setManufacture({
              ...manufacture,
              portions: manufacturePortions,
              items: manufacture?.items?.map(el => ({
                ...el,
                portions: el?.portions?.map(portion => ({
                  ...portion,
                  description: el?.item
                }))
              }))
            });
            setCurrentTransformationCardItems(manufacture);
            setCardDate(manufacture.date);
            setPopoverData('pause');
            handlePopoverClick(e);
          };
          break;
        case 'finish':
          let textStart = ''
          let textFinish = ''
          const dateStartedFormatted = moment(actionStarted?.date || manufacture?.created_at).format('DD/MM')

          if (actionStarted || manufacture?.created_at) {
            textStart = hourStart || hourInclusion

            if (dateStart !== dateFinished) {
              textStart = `${dateStartedFormatted} ${hourStart || hourInclusion}`
            }
          } 

          if (actionFinished) {
            textFinish = ` às ${hourFinished} (${actionFinished?.user})`
            moment(dateStartedFormatted).diff(moment(), 'hours')
            if (dateStart !== dateFinished) {
              const dateFinishedFormatted = moment(actionFinished.date).format('DD/MM')
              textFinish = ` às ${dateFinishedFormatted} ${hourFinished} (${actionFinished?.user})`
            }
          }

          duration = moment.duration(moment(actionFinished?.date).startOf('minute').diff(moment(actionStarted?.date || manufacture?.created_at).startOf('minute')));
          diffHours = Math.floor(duration.asHours());
          diffMinutes = Math.floor(duration.asMinutes()) % 60;

          statusText = (
            <p>
              <b>Finalizado :)</b>
              {ValidationLength(`${textStart} ${textFinish}`, 30)}
            </p>
          );
          statusColor = '#004D33';
          statusBackground = '#D2F9D6';
          actionButton = !isPrintEnabled 
          ? <img src={CheckedCircleIcon} /> 
          : manufacture?.hasPortions
          ? <img src={ClockGreenIcon} />
          : <img src={ClockGreenDisabledIcon} />;
          
          tooltip = !isPrintEnabled ? null : manufacture?.hasPortions ? "Produzido com porcionamento" : "Produzido sem porcionamento";
          onClick = (e) => {
            const hashId = GenerateHashId()
            const manufacturePortions = isTransformation
              ? manufacture?.portions
              : manufacture?.portions?.length 
                ? manufacture?.portions?.map(el => ({
                  ...el,
                  fakeKey: crypto.randomUUID()
                })) 
                : [{ quantity: null, labelQuantity: '', printed: false, id: hashId }]

            setManufacture({
              ...manufacture,
              portions: manufacturePortions,
              items: manufacture?.items?.map(el => ({
                ...el,
                portions: el?.portions?.map(portion => ({
                  ...portion,
                  description: el?.item
                }))
              }))
            });
            setCurrentTransformationCardItems(manufacture);
            setCardDate(manufacture.date);
            type === 'recipe'
              ? setPopoverData('start')
              : setPopoverData('finishTransformation');
            handlePopoverClick(e);
          };
          break;
      }

      if (fakeReturn) return;

      return (
        <Tooltip
          title={
            <p className="mb0" style={{ padding: '2px 6px' }}>
              {tooltip}
            </p>
          }
          aria-label="filters"
          placement="right-start"
          disableHoverListener={!tooltip}
        >
          <IconButton
            edge="start"
            size="small"
            color="inherit"
            onClick={onClick}
            aria-label="close"
            style={{
              outline: '0',
              cursor: status === 'canceled' && 'auto'
            }}
          >
            {actionButton}
          </IconButton>
        </Tooltip>
      );
    };

    const handleQuantityField = (status, initialValue, type) => {
      if (status?.toLowerCase() === 'waiting') {
        return (
          <CurrencyTextField
            margin="none"
            variant="standard"
            size="small"
            currencySymbol=""
            minimumValue="0"
            maximumValue="999999999"
            outputFormat="string"
            decimalCharacter=","
            digitGroupSeparator="."
            decimalPlaces={3}
            decimalPlacesShownOnBlur={3}
            placeholder="Qtd"
            type="text"
            name="quantity"
            fullWidth
            value={initialValue || null}
            textAlign="center"
            align="center"
            style={{
              align: 'center',
              textAlign: 'right',
              marginTop: '5.95px'
            }}
            InputProps={{
              maxLength: 8,
              classes: { input: classes.input },
              style: { textAlign: 'right' }
            }}
            onChange={(e) => {
              setManufacture(manufacture);
              setUpdateValue(
                parseFloat(e.target.value) !==
                  parseFloat(initialValue.toFixed(3))
              );
            }}
            onBlur={(e, value) => {
              if (
                !updateValue &&
                parseFloat(initialValue.toFixed(3)) === parseFloat(value)
              )
                return;

              if (type === 'yield') {
                handleCardQuantity(
                  index,
                  manufacture.quantity || 1,
                  undefined,
                  undefined,
                  parseFloat(value)
                );
              } else {
                handleCardQuantity(
                  index,
                  parseFloat(value),
                  undefined,
                  undefined,
                  undefined
                );
              }

              setUpdateValue(false);
            }}
          />
        );
      }
      return initialValue
        ? parseFloat(initialValue).toLocaleString('pt-br', {
            minimumFractionDigits: 3
          })
        : '0,000';
    };

    const handleLossMonetary = () => {
      if (
        lossManufactured === null ||
        lossManufactured === '' ||
        status !== 'finish'
      ) {
        return `-`;
      }

      if (!diffViewMonetary) {
        return lossManufactured || '-';
      }

      return lossManufacturedMonetary || '-';
    };

    const handlePreparationClick = (url) => {
      const encodedUrl = btoa(url);
      localStorage.setItem('preparationUrl', encodedUrl);
    };

    return (
      <>
        <tr valign="center" className={`${!manufacture?.visible && 'dNone'}`}>
          <td className="description center">
            &nbsp;
          </td>

          <td className="description pr8">
            <List component="nav" className="list">
              <ListItem className="listItem p0">
                <div className="defaultBox w100">
                  <div className="upperLine">
                    {renderCardDescriptionInfos(manufacture, type, handlePreparationClick)}
                  </div>

                  <div className="bottomLine">
                    {manufacture?.type === "TRANSFORMATION" 
                      ? renderItemTransformationInfos(manufacture, manufacture?.itemTransformation, index)
                      : ''
                    }
                  </div>
                </div>
              </ListItem>
            </List>
          </td>

          <td className="description right p8" style={{ borderLeft: 'solid 1px #D0D3E2' }}>
            <div className="defaultBox">
              <div className="upperLine">
                {manufacture?.type === "TRANSFORMATION" 
                  ? ''
                  : renderCardStock(manufacture)
                }
              </div>

              <div className="bottomLine">
                {manufacture?.type === "TRANSFORMATION" 
                  ? renderCardStock(manufacture, manufacture?.itemTransformation)
                  : ''
                }
              </div>
            </div>
          </td>

          <td className="description right p8" style={{ borderLeft: 'solid 1px #D0D3E2' }}>
            <div className="defaultBox">
              <div className="upperLine">
                {manufacture?.type === "TRANSFORMATION" 
                  ? ''
                  : renderCardDuration(manufacture, disableDurationDialog)
                }
              </div>

              <div className="bottomLine">
                 {manufacture?.type === "TRANSFORMATION" 
                  ? renderCardDuration(manufacture, disableDurationDialog, manufacture?.itemTransformation)
                  : ''
                }
              </div>
            </div>
          </td>

          <td
            className="description right p8"
            style={{ background: 'rgba(117, 131, 240, .2)', borderLeft: 'solid 1px #454A67' }}
          >
            <div className="defaultBox">
              <div className="upperLine">
                {manufacture?.type === "TRANSFORMATION" 
                  ? ''
                  : renderCardProduction(manufacture, 'RECIPE', index)
                }
              </div>

              <div className="bottomLine">
                {manufacture?.type === "TRANSFORMATION" 
                  ? renderCardProduction(manufacture, "TRANSFORMATION", index)
                  : ''
                }

                {manufacture?.type === "RECIPE" &&
                  <div className="dFlex w100">
                    <span 
                      className="dFlex justifyEnd cursorPointer disabledField" 
                      style={{ width: '32%' }}
                    >
                      {manufacture?.viewMethod === 2 ? 'Receitas' : 'Rend.'}
                    </span>

                    <div className='disabledField' style={{ width: "48%", margin: '0 5px', padding: '0 2px' }}>
                      {manufacture?.viewMethod === 2 ? manufacture?.quantity?.toFixed(3) : manufacture?.yield.toFixed(3)}
                    </div>
                    
                    <span className="dFlex disabledField" style={{ width: "20%" }}>
                      {manufacture?.viewMethod === 2 ? '' : manufacture.un?.abbreviation}
                    </span>
                  </div>
                }
              </div>
            </div>
          </td>

          <td className="description right p8 font-weight-bold" style={{ background: 'rgba(117, 131, 240, .2)', borderLeft: 'solid 1px #D0D3E2' }}>
            <div className="defaultBox">
              <Tooltip
                title={
                  <div className="dFlex flexColumn" style={{ padding: '4px' }}>
                    {loadingCardCostInfos ?
                      <div className="countsCircularProgressBar dFlex justifyCenter">
                        <CircularProgress color="#FFF" />
                      </div>  
                    : null}

                    {!loadingCardCostInfos && cardCostInfos?.costs ?
                      <>
                        <p className="bold mb5">
                          Custo Unitário: {" "}
                          R$ {cardCostInfos?.costs?.costUnit?.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })} {manufacture.un?.abbreviation}
                        </p>

                        <p className="bold mb0">
                          Custo Total: {" "}
                          R$ {(cardCostInfos?.costs?.costUnit * (manufacture?.manufactured || manufacture?.yield || 0))?.toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })} {manufacture.un?.abbreviation}                          
                        </p>
                      </>
                    : null}
                  </div>
                }
                aria-label="filters"
                placement="right-start"
                disableHoverListener={hideManufacturedAndDiffInfos}
              >
                <div 
                  className="upperLine justifyEnd alignCenter"
                  onMouseEnter={() => {
                    setLoadingCardCostInfos(true)
                    handleGetCardInfos(manufacture, false)
                  }}
                  onMouseLeave={() => {
                    setCardCostInfos()
                  }}
                >
                  {hideManufacturedAndDiffInfos
                    ? `-`
                    : handleFields(manufacture).manufactured || '-'
                  }
                </div>
              </Tooltip>

              <div className="bottomLine"/>
            </div>
          </td>

          <td className="description right pr8" style={{ background: 'rgba(117, 131, 240, .2)' }}>
            <div className="defaultBox">
              <div className="upperLine justifyEnd alignCenter">
                {hideManufacturedAndDiffInfos
                  ? `-`
                  : 
                    <div
                      className="dFlex alignCenter justifyBetween bold"
                      style={{
                        height: 20,
                        lineHeight: 2.15,
                        width: '100%',
                        margin: '0 0 0 auto',
                        borderRadius: 10,
                        boxShadow: '0px 4px 4px 0px #00000040',
                        color: handleFields(manufacture)?.lossManufacturedStyle?.textColor,
                        background: handleFields(manufacture)?.lossManufacturedStyle?.bgColor
                      }}
                    >
                      {handleLossMonetary() ?
                        <>
                          <div
                            className="dFlex alignCenter justifyEnd"
                            style={{
                              width: '70%',
                              fontWeight: 700,
                              fontSize: '12px',
                              paddingRight: 3,
                              color: handleFields(manufacture)?.lossManufacturedStyle?.textColor,
                            }}
                          >
                            {handleLossMonetary()}
                          </div>

                          <PercentBox background={handleFields(manufacture)?.lossManufacturedStyle?.background}>
                            {handleFields(manufacture).diffPercentage && status === 'finish' 
                              ? handleFields(manufacture).formattedDiffPercentage
                              : '-'
                            }

                            {handleFields(manufacture).diffPercentage && status === 'finish' ? '%' : ''}
                          </PercentBox>
                        </>
                        : '-'
                      }
                    </div>
                }
              </div>

              <div className="bottomLine"/>
            </div>
          </td>

          <td
            className="description pl8"
            style={{ borderLeft: 'solid 1px #454A67' }}
          >
            <div className="dFlex w100 mb10">
                {handleActionButton(status, index, quantity, true)}
           

              <Tooltip
                title={
                  <TooltipFinish>
                    <b>INCLUSÃO DA FICHA</b>
                    <p>Data: {dateInclusion}</p>
                    <p>Horário: {hourInclusion}hs</p>
                    <p>Usuário: {userInclusion}</p>

                    {actionStarted && <br />}
                    {actionStarted && <b>INÍCIO DA PRODUÇÃO</b>}
                    {actionStarted && <p>Data: {dateStart}</p>}
                    {actionStarted && <p>Horário: {hourStart}hs</p>}
                    {actionStarted && <p>Usuário: {userStart}</p>}

                    {actionPaused && <br />}
                    {actionPaused && <b>PAUSA</b>}
                    {actionPaused && <p>Data: {datePaused}</p>}
                    {actionPaused && <p>Horário: {hourPaused}hs</p>}
                    {actionPaused && <p>Usuário: {userPaused}</p>}

                    {actionRestarted && <br />}
                    {actionRestarted && <b>REINÍCIO</b>}
                    {actionRestarted && <p>Data: {dateRestarted}</p>}
                    {actionRestarted && <p>Horário: {hourRestarted}hs</p>}
                    {actionRestarted && <p>Usuário: {userRestarted}</p>}

                    {actionFinished && <br />}
                    {actionFinished && <b>FINALIZAÇÃO</b>}
                    {actionFinished && <p>Data: {dateFinished}</p>}
                    {actionFinished && <p>Horário: {hourFinished}hs</p>}
                    {actionFinished && <p>Usuário: {userFinished}</p>}

                    {actionCanceled && <br />}
                    {actionCanceled && <b>CANCELAMENTO</b>}
                    {actionCanceled && <p>Data: {dateCanceled}</p>}
                    {actionCanceled && <p>Horário: {hourCanceled}hs</p>}
                    {actionCanceled && <p>Usuário: {userCanceled}</p>}
                  </TooltipFinish>
                }
                placement='right-start'
              >
                <ButtonStatus
                  className="productionButtonStatus"
                  color={statusColor}
                  background={statusBackground}
                >

                  {handleActionButton(status, index, quantity)}

                  {statusText}

                  {isFinished &&
                    <div className={`finishedTimeCircle ${diffHours || diffMinutes ? 'positiveTime' : 'noTime'}`}>
                      <span>
                      {`
                          ${diffHours > 0 ? diffHours : ''}
                          ${diffHours > 0 && diffMinutes > 0 ? ':' : ''}
                          ${diffMinutes > 0 
                            ? diffMinutes < 10
                              ? `0${diffMinutes}`
                              : diffMinutes
                            : diffMinutes === 0 
                              ? '0'
                              : '0'
                          }
                        `}
                      </span>

                      <span className="mt8">
                        {diffHours > 0 
                        ? diffHours === 1 
                          ? 'h'
                          : 'hs'
                        : 'min'
                        }
                      </span>
                    </div>
                  }
                </ButtonStatus>
              </Tooltip>
            </div>
          </td>

          <td className="description center p8 pr0">
            <div className="dFlex justifyCenter alignCenter flexColumn">
              <div className="bold" style={{ fontSize: 12, lineHeight: 1.2 }}>
                {moment(manufacture.date).add(3, 'hour')?.format('DD/MM/YY')}
              </div>
              
              <div className="dFlex justifyBetween">
                <Tooltip
                  disableHoverListener={status === 'finish'}
                  title="Cancelar produção"
                >
                  <div>
                    <IconButton
                      aria-label="delete"
                      disabled={
                        manufacture.status ===
                        'CANCELED' /* || manufacture.status === "FINISH" */
                      }
                    onClick={() => {
                      handleDialogClickOpen();
                      setDeleteData(manufacture);
                    }}
                    style={{ padding: 0, outline: 0 }}
                    >
                      <img src={DeleteIcon} style={{ width: '20px' }} alt="Delete" />
                    </IconButton>
                  </div>
                </Tooltip>
                
                {(isPrintEnabled && haveSomePrintLabel) ?
                  <div className="ml5">
                    <img 
                      onClick={() => {
                        if (!haveSomePrintLabel) return;

                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'confirmPrint'
                              ? {
                                  ...modal,
                                  open: true,
                                  currentManufacture: manufacture
                                }
                              : modal
                          )
                        );
                      }}
                      className={haveSomePrintLabel ? 'cursorPointer' : 'cursorAuto'}
                      src={haveSomePrintLabel ? PrinterIcon : PrinterDisabledIcon} 
                      style={{ width: '20px' }} 
                      alt="PrinterIcon" 
                    />
                  </div>
                : null}
              </div>
            </div>
          </td>

          <td className="description center">
            &nbsp;
          </td>
        </tr>

        {
          type === 'recipe' &&
          cards &&
          cards.find((item, cardIndex) => cardIndex === index)
            ? handleRecipe(
                manufacture,
                manufactures.find((el) => el._id === manufacture._id)?.open,
                index
              )
            : type === 'transformation' && cards?.find((item, cardIndex) => cardIndex === index)
              ? handleTransformation(
                  manufacture,
                  manufactures.find((el) => el._id === manufacture._id)?.open,
                  index
                )
              : null
        }

        <tr>
          <td colSpan="10" className={`${!manufacture?.visible && 'dNone'}`}>
            <hr style={{ backgroundColor: '#666770' }} />
          </td>
        </tr>
      </>
    );
  });
}

export default DesktopRows;
